.newProfileSidebar {
  grid-column: 1;
  grid-row: 2;
  display: flex;
  position: relative;
  width: 392px;
  height: calc(var(--content-height) - 64px);
  padding: var(--spacing-16) var(--spacing-24);
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;

  .newProfileHeader {
    display: flex;
    height: 44px;
    justify-content: space-between;
    align-items: center;
    flex-shrink: 0;
    align-self: stretch;
  }

  .newProfileContent {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: var(--spacing-16);
    width: 100%;
    margin-bottom: auto;
    height: calc(100% - 88px);

    .textInput {
      width: 100%;
    }

    .newProfileContainer {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      gap: var(--spacing-04);
      height: calc(100% - 128.5px);

      .pinList {
        display: flex;
        flex-direction: column;
        gap: var(--spacing-04);
        max-height: calc(100% - 104.5px);
        overflow-y: auto;
      }

      .addAnotherPin {
        width: fit-content;
      }
    }
  }

  .newProfileFooter {
    height: 44px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: var(--spacing-08);
  }
}

.nameLength {
  color: var(--sparky-grey-400) !important;
}
